export const FETCH_SITE_ATTENDANCE = 'views/users/FETCH_SITE_ATTENDANCE'